import React from "react";
import { Icon } from "./Icon.jsx";

/* Tag / chip — filter or attribute token, optionally removable. */
export function Tag({ children, icon, onRemove, selected = false, style, ...rest }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        height: 28,
        padding: onRemove ? "0 6px 0 12px" : "0 12px",
        borderRadius: "var(--radius-pill)",
        background: selected ? "var(--mint-light)" : "var(--white)",
        color: "var(--text-body)",
        boxShadow: selected
          ? "inset 0 0 0 1px var(--mint-deep)"
          : "inset 0 0 0 1px var(--border)",
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 13,
        lineHeight: 1,
        whiteSpace: "nowrap",
        ...style,
      }}
      {...rest}
    >
      {icon ? <Icon name={icon} size={14} /> : null}
      {children}
      {onRemove ? (
        <button
          type="button"
          aria-label="Remove"
          onClick={onRemove}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 18,
            height: 18,
            border: "none",
            background: "transparent",
            color: "var(--text-muted)",
            cursor: "pointer",
            borderRadius: "50%",
          }}
        >
          <Icon name="x" size={13} />
        </button>
      ) : null}
    </span>
  );
}

export default Tag;
